<template>
  <v-row no-gutters :class="[paddingRight, 'text-break']">
    <v-col>
      <slot name="sectionTitle"></slot>
      <v-row no-gutters :class="[alignClass, flexWrap, rowClass]">
        <v-col cols="1" v-if="hasIconColumn" style="min-width: 40px" :class="[rowClass]">
          <slot name="actionIcon">
            <v-row no-gutters class="justify-center">
              <v-col cols="auto">
                <v-icon :color="iconColor" v-if="icon" v-on="$listeners">
                  {{ icon }}
                </v-icon>
              </v-col>
            </v-row>
          </slot>
        </v-col>
        <v-col
          style="min-width: 0"
          :cols="slotCols"
          :class="{
            'border-top': borderTop,
            'border-bottom': borderBottom,
          }"
        >
          <slot> </slot>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'SidebarRow',
  props: {
    hasIconColumn: {
      type: Boolean,
      default: true,
    },
    icon: {
      type: String,
      default: null,
    },
    iconColor: {
      type: String,
      default: 'rgba(0,0,0,0.7)',
    },
    borderTop: {
      type: Boolean,
      default: false,
    },
    borderBottom: {
      type: Boolean,
      default: false,
    },
    alignClass: {
      type: String,
      default: 'align-baseline',
    },
    slotCols: {
      type: String,
      default: '',
    },
    rowClass: {
      type: String,
      default: '',
    },
    flexWrap: {
      type: String,
      default: 'flex-nowrap',
    },
    paddingRight: {
      type: String,
      default: 'pr-5',
    },
  },
};
</script>

<style lang="scss" scoped>
.border-top {
  @include border(top);
}
.border-bottom {
  @include border(bottom);
}
</style>
